import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ButtonLink from '../utility/ButtonLink';
import RatingDisplay from '../Reviews/RatingDisplay';
import { toggleActiveTripPopUp, setActiveTripPopUp } from '../../actions/trip';

import {
  extractFirstContentChunk,
  getDiscPricePerPax,
  getPricePerPax,
  getPriceByPax,
  createPriceLabel,
  createDiscountLabel,
  formatVendorNameBold,
  findMinMaxPaxRate
} from '../../js/utility';

import { productClickGA } from '../../js/analytics';

import { withTranslation } from 'react-i18next';

import iconLocation from '../../images/icons/icon_32_location.png';
import iconDuration from '../../images/icons/icon_32_duration.png';
import iconStar from '../../images/icons/icon_32_star.png';
import iconPax from '../../images/icons/icon_32_noofpax.png';
import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';
import iconLeft from '../../images/icons/icon_72_leftchev.png';
import iconRight from '../../images/icons/icon_72_rightchev.png';
import iconClose from '../../images/icons/icon_32_close.png';

class TripPopUp extends Component {
  constructor(props) {
    super(props);
    this.popupRef = React.createRef();
    this.changePopup = this.changePopup.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.popupRef.current.focus();
  }

  changePopup(amount) {
    const { trips, setActiveTripPopUp, activeTripId } = this.props;
    const currIndex = trips.findIndex(trip => trip.id === activeTripId);
    const maxTrips = trips.length;
    if (
      (currIndex >= maxTrips - 1 && amount > 0) ||
      (currIndex === 0 && amount < 0)
    ) {
      return;
    }
    let newId = trips[currIndex + amount].id;
    setActiveTripPopUp(newId);
  }

  handleKeyPress(e) {
    if (e.key === 'ArrowLeft') {
      this.changePopup(-1);
    } else if (e.key === 'ArrowRight') {
      this.changePopup(1);
    }
  }

  render() {
    const { trips, activeTripId, toggleActiveTripPopUp, t } = this.props;

    const currentIndex = trips.findIndex(trip => trip.id === activeTripId);
    const currentTrip = trips.find(trip => trip.id === activeTripId);
    const maxTrips = trips.length;
    const vehicle = currentTrip.recommended_vehicle;

    const isByAge = currentTrip.trip_price.price_type === 'by_age';
    const isPerTrip = currentTrip.trip_price.is_per_trip;
    const isByPax = currentTrip.trip_price.price_type === 'by_pax';

    let pricePerPax = getPricePerPax(currentTrip.trip_price, {
      pax_max: currentTrip.pax_max
    });
    const discPricePerPax = getDiscPricePerPax(
      currentTrip.trip_price,
      { pax_max: currentTrip.pax_max },
      currentTrip.trip_discount
    );

    const lowestAdultPax = findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'min');

    // Include insurance, SST, & service fee
    const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
    const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
    const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;
    pricePerPax.adult = pricePerPax.adult + (insurance * lowestAdultPax);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * serviceFee);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * sstPercentage);

    let priceStr = createPriceLabel(pricePerPax, discPricePerPax);
    let discountStr = createDiscountLabel(currentTrip.trip_discount);

    if (currentTrip.slug === 'ford-ranger-training-experience-sabah'){
      priceStr = 'From ' + priceStr.adult + ' per vehicle';
    }
    else if (currentTrip.slug === 'off-roading-durian-adventure' || currentTrip.slug === 'advanced-4wd-adventure-off-road-course-at-m4trec-morning-session'){
      priceStr = priceStr.adult + ' (1 pax)';
    }
    else if (currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai'){
      priceStr = 'From ' + priceStr.adult + ' (Up to 4 pax)';
    }
    else if (isPerTrip) {
      priceStr = t('gen:pricePerTrip', {
        price: priceStr
      });
    } else if (isByAge) {
      priceStr = t('gen:fromPricePerPax', {
        price: priceStr.adult
      }).concat('**');
    } else if (isByPax) {
      priceStr = t('gen:fromPriceByPax', {
        price: priceStr.adult,
        minPax: currentTrip.pax_min
      });
    } else {
      priceStr = t(
        `gen:${currentTrip.pax_min > 1 ? 'fromPricePerPax' : 'pricePerPax'}`,
        {
          price: priceStr
        }
      ).concat(currentTrip.pax_min > 1 ? '*' : '');
    }

    return (
      <>
        <div
          className='fe-overlay'
          onClick={() => toggleActiveTripPopUp(false)}
        />
        <div
          className='fe-trip-popup-container'
          onKeyDown={this.handleKeyPress}
          ref={this.popupRef}
          tabIndex='0'
        >
          {discountStr ? (
            <div className='fe-discount-label big'>
              {t('gen:discountOff', { discountAmount: discountStr })}
            </div>
          ) : null}
          {currentIndex > 0 ? (
            <div
              onClick={() => this.changePopup(-1)}
              className='fe-trip-arrow left'
            >
              <img src={iconLeft} alt='' />
            </div>
          ) : null}
          {currentIndex + 1 < maxTrips ? (
            <div
              onClick={() => this.changePopup(1)}
              className='fe-trip-arrow right'
            >
              <img src={iconRight} alt='' />
            </div>
          ) : null}
          <div className='fe-trip-popup'>
            <div className='fe-trip-popup-img'>
              <div
                className='fe-trip-close-btn'
                onClick={() => toggleActiveTripPopUp(false)}
              >
                <img src={iconClose} alt='' />
              </div>
              {currentIndex > 0 ? (
                <div
                  onClick={() => this.changePopup(-1)}
                  className='fe-trip-arrow mobile left'
                >
                  <img src={iconLeft} alt='' />
                </div>
              ) : null}
              {currentIndex + 1 < maxTrips ? (
                <div
                  onClick={() => this.changePopup(1)}
                  className='fe-trip-arrow mobile right'
                >
                  <img src={iconRight} alt='' />
                </div>
              ) : null}
              <img
                className='fe-trip-popup-img-desktop'
                src={currentTrip.popout.desktop_view}
                alt=''
              />
              <img
                className='fe-trip-popup-img-mobile'
                src={currentTrip.popout.mobile_view}
                alt=''
              />
            </div>
            <div className='fe-trip-popup-details'>
              <h2 className='fe-trip-popup-title'>{currentTrip.title}</h2>
              {/* <div className='fe-trip-popup-rating'>
                <RatingDisplay
                  showTotal
                  totalRatings={currentTrip.reviews}
                  rating={currentTrip.rating}
                />
              </div> */}
              <div className='fe-trip-popup-schedule'>
                <div className='fe-trip-popup-icon-info'>
                  <img src={iconLocation} alt='' />
                  <span>{currentTrip.location_text}</span>
                </div>
                <div className='fe-trip-popup-icon-info'>
                  <img src={iconDuration} alt='' />
                  <span>{currentTrip.duration}</span>
                </div>
                {/* <div className='fe-trip-popup-icon-info'>
                  <img src={iconStar} alt='' />
                  <span>Difficulty: {(currentTrip.difficulty === 1)? 'Easy' : (currentTrip.difficulty === 2)? 'Intermediate' : 'Hard'}</span>
                </div> */}
                {currentTrip.pax_min > 1 ? (
                  <div className='fe-trip-popup-icon-info'>
                    <img src={iconPax} alt='' />
                    <span>
                      {t('gen:recNumPax', { num: currentTrip.pax_max })}
                    </span>
                  </div>
                ) : null}
              </div>
              <div className='fe-trip-popup-info'>
                {(currentTrip.vendor && currentTrip.vendor !== '') && (currentTrip.vendor !== 'Ice Age Event Management Sdn Bhd' && currentTrip.vendor !== 'IPG Mediabrands') ? (
                  <h3
                    className='fe-trip-popup-provided-by'
                    dangerouslySetInnerHTML={{
                      __html: t('gen:getawayProvidedBy', {
                        provider: formatVendorNameBold(
                          currentTrip.vendor,
                          currentTrip.vendor_no
                        )
                      })
                    }}
                  />
                ) : null}
                {currentTrip.description && currentTrip.description !== '' ? (
                  <div
                    className='fe-trip-popup-desc'
                    dangerouslySetInnerHTML={{
                      __html: extractFirstContentChunk(currentTrip.description)
                    }}
                  />
                ) : null}
                {/* <h4 className='fe-trip-popup-rec'>
                  {currentTrip.is_own_vehicle
                    ? t('gen:requirements')
                    : t('gen:recommendedRanger')}
                </h4>
                <div className='fe-trip-popup-rec-img'>
                  {!currentTrip.is_own_vehicle ? (
                    <div className='fe-trip-popup-thumb'>
                      <div className='fe-u-thumb-3by1'>
                        <img src={vehicle.img_url} alt='' />
                      </div>
                    </div>
                  ) : null}
                  <div className='fe-trip-popup-rec-text'>
                    {!currentTrip.is_own_vehicle ? null : (
                      <img src={iconBYOC} alt='' />
                    )}
                    {!currentTrip.is_own_vehicle ? (
                      <div className='fe-trip-popup-vehicle'>
                        <div className='fe-trip-popup-vehicle-model'>
                          {vehicle.model}
                        </div>
                        <div className='fe-trip-popup-vehicle-subtext'>
                          {vehicle.subtext}
                        </div>
                      </div>
                    ) : (
                      <span>{t('gen:bringOwnRanger')}</span>
                    )}
                  </div>
                </div> */}
                {(currentTrip.slug === 'island-retreat-in-mantanani' || currentTrip.slug === 'beach-clean-up') ? null : (
                  <div className='fe-trip-popup-disclamer'>
                    {(currentTrip.slug === 'tabin-wildlife-safari-adventure' || currentTrip.slug === 'marine-life-of-mabul' || currentTrip.slug === 'escape-to-kapalai-paradise') ? <p>{t('gen:disclamerBookWithFordMalaysia')}</p> : (currentTrip.title == 'Ford Ranger Raptor Sepang Experience' ?  <p>{t('gen:disclamerRaptor')}</p> :  <p>{t('gen:disclamer')}</p>)}
                  </div>
                )}
              </div>
              <div className='fe-trip-popup-more'>
                <div className='fe-trip-popup-price'>
                  { currentTrip.slug !== 'ford-ranger-training-experience-sabah' || !currentTrip.upcoming ?
                    (
                      <span
                        className='fe-trip-popup-price-text'
                        dangerouslySetInnerHTML={{
                          __html: priceStr
                        }}
                      />
                    ) : null
                  }
                </div>
                <ButtonLink
                  className='fe-u-btn'
                  // onClick={() => productClickGA(currentTrip.title)}
                  onClick={() =>
                    productClickGA(
                      currentTrip.id,
                      currentTrip.title,
                      currentTrip.vendor
                    )
                  }
                  to={`/trips/${currentTrip.slug}`}
                >
                  {t('gen:findOutMore')}
                </ButtonLink>
              </div>
              {isPerTrip ? null : isByAge ? (
                <div className='fe-trip-popup-note'>
                  <p>** {t('gen:priceByAgeNote')}</p>
                </div>
              ) : currentTrip.pax_min > 1 ? (
                <div className='fe-trip-popup-note'>
                  <p>* {t('gen:pricePerPaxNote')}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

TripPopUp.propTypes = {
  trips: PropTypes.array.isRequired,
  activeTripId: PropTypes.number.isRequired,
  setActiveTripPopUp: PropTypes.func.isRequired,
  toggleActiveTripPopUp: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ tripState }) => ({
  activeTripId: tripState.activeTripId
});

const mapDispatchToProps = {
  setActiveTripPopUp,
  toggleActiveTripPopUp
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TripPopUp)
);
